import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const AngleRight = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-angle-right',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.angleRight.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="M18,12c0,0.53-0.21,1.04-0.58,1.42l-7.99,7.99c-0.78,0.78-2.05,0.78-2.84,0c-0.79-0.78-0.78-2.05,0-2.84L13.18,12L6.59,5.43c-0.78-0.78-0.78-2.05,0-2.84c0.78-0.78,2.05-0.78,2.84,0l0,0l7.99,7.99C17.79,10.96,18,11.47,18,12z"
      />
    </IconSvg>
  );
};

export default memo(AngleRight);
